import Vue from 'vue'

// axios
import axios from 'axios'

const apiOrigin = (process.env.VUE_APP_API_URL || window.location.origin)
  .replace(/\/$/, '')
  .replace(/\/api(?:\/v1)?$/, '')

const normalizeApiUrl = url => {
  if (!url || typeof url !== 'string') return url
  if (/^(https?:)?\/\//.test(url) || url.startsWith('data:')) return url

  const clean = url.trim().replace(/^\/+/, '')

  if (!clean) return url
  if (clean === 'api') return '/api/v1'
  if (clean === 'api/v1') return '/api/v1'
  if (clean.startsWith('api/v1/')) return `/${clean}`
  if (clean === 'v1') return '/api/v1'
  if (clean.startsWith('v1/')) return `/api/${clean}`
  if (clean.startsWith('api/')) return `/api/v1/${clean.slice(4)}`

  return url
}

const axiosIns = axios.create({
  baseURL: apiOrigin,
})

axiosIns.interceptors.request.use(config => {
  config.url = normalizeApiUrl(config.url)
  return config
})

Vue.prototype.$http = axiosIns

export default axiosIns
